import { Box, Skeleton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React from "react";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";

export default function SkeletonPoolCard() {
  const { colors } = useTheme();
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={4}
      flexGrow={1}
      maxHeight={"calc(100vh - 18rem)"}
      style={{
        overflowY: "scroll",
        scrollbarWidth: "thin",
        scrollbarbehavior: "smooth",
      }}
    >
      {[...Array(3)].map((_, index) => (
        <Box
          key={index}
          display="grid"
          gap="1.5rem"
          sx={{
            padding: "1.25rem 2rem 2rem 2rem",
            borderRadius: "1.5rem",
            backgroundColor: colors.background.accent,
          }}
        >
          {/* Header Section */}
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Skeleton
              variant="text"
              width="30%"
              height={30}
            />
            <Skeleton variant="circular">
              <MoreVertIcon />
            </Skeleton>
          </Box>

          {/* Details Section */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 3fr",
              gap: "1rem",
            }}
          >
            {[...Array(3)].map((_, index) => (
              <React.Fragment key={index}>
                {/* Label */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Skeleton
                    variant="text"
                    width="80px"
                    height="25px"
                  />
                </Box>
                {/* Value */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Skeleton
                    variant="text"
                    width="90%"
                    height="25px"
                  />
                </Box>
              </React.Fragment>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
